<script setup lang="ts">
import { ref, computed, onMounted, provide, defineExpose } from 'vue'
import { useAuthStore } from '@/views/Authentication/store'
import { useThemeStore } from '@/stores/theme'
import { useGlobalStore } from '@/stores/global'
import { useDisplay } from 'vuetify'


import AppBar2 from './components/AppBar2.vue'
import AppSidebar2 from './components/AppSidebar2.vue'
const themeStore = useThemeStore()
const authStore = useAuthStore()
const globalStore = useGlobalStore()
const { mobile } = useDisplay()

const drawer = ref<boolean>(true)
const isMobileLocal = ref<boolean>(false)

const currentTheme = computed(() => themeStore.currentTheme)
const userProfile = computed(() => authStore.userProfile)
console.log('User Profile:', userProfile.value)
const loadData = computed(() => globalStore.loadData)

const toggleDrawer = () => {
  drawer.value = !drawer.value
}

const hideDrawer = () => {
  drawer.value = false
}

defineExpose({ hideDrawer })
provide('hideDrawer', hideDrawer)

onMounted(() => {
  window.addEventListener('resize', () => {
    isMobileLocal.value = window.innerWidth <= 500
  })
  isMobileLocal.value = window.innerWidth <= 500
  globalStore.setLoadData(true)
  if (isMobileLocal.value) drawer.value = false
})
</script>

<template>
  <v-card class="bg-background" elevation="0">
    <AppBar2 :toggle-drawer="toggleDrawer" :user="userProfile" :theme="currentTheme" @logout="authStore.logOut"
      @toggle-theme="themeStore.toggleTheme" />
    <!-- <AppSidebar v-model:drawer="drawer" :is-mobile="isMobileLocal" @logout="authStore.logOut" />
    <AppHeader :drawer="drawer" :toggle-drawer="toggleDrawer" :user="userProfile" :theme="currentTheme"
      @logout="authStore.logOut" @toggle-theme="themeStore.toggleTheme" /> -->
    <AppSidebar2 :drawer="drawer" :theme="currentTheme" :isMobile="$vuetify.display.mobile"
      @update:drawer="drawer = $event" :user-profile="userProfile" @logout="handleLogout" />
    <v-main>
      <v-container v-if="loadData">
        <div>
          <slot></slot>
        </div>
        <div class="footer-text">
          Desarrollado por TorcazaDev <span class="heart-icon">®</span> Todos los derechos reservados
        </div>
      </v-container>
      <template v-else>
        <div class="loading">
          <v-progress-circular size="60" class="mx-auto my-auto" indeterminate color="primary" />
        </div>
      </template>
    </v-main>
  </v-card>
</template>

<style>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.card-rounded {
  border-radius: 20px;
}

.footer-text {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: #666;
  text-align: center;
  padding: 10px;
  background-color: transparent;
}

.footer-text .heart-icon {
  color: #000;
  margin: 0 3px;
}
</style>
